import { api, qs } from './client.js';
import type { Paginated, FzProduct, FzProductInput, FzPrize, FzPrizeHistoryEntry, FzPrizeInput } from './types.js';

export const fanzaApi = {
  products: (filters: {
    page?: number;
    perPage?: number;
    q?: string;
    sort?: string;
    dir?: string;
    categoryCode?: string;
    status?: string;
  }) => api.get<Paginated<FzProduct>>(`/fanza/products${qs({ ...filters })}`),

  product: (randomboxId: number) => api.get<FzProduct>(`/fanza/products/${randomboxId}`),

  /** 원본 fanza/product/product_modify.php 의 modifyexe. server shared/product-crud.ts 가 처리한다. */
  updateProduct: (randomboxId: number, body: FzProductInput) =>
    api.patch<{ id: number }>(`/fanza/products/${randomboxId}`, body),

  /**
   * 원본 fanza/product/product_copy.php: 폼 값으로 새 상품을 만들고, 원본 상품의
   * 경품(fanza_prizes)도 새 상품 밑으로 복제한다(품절 표시는 풀린 채).
   */
  copyProduct: (randomboxId: number, body: FzProductInput) =>
    api.post<{ id: number; sourceId: number; copiedChildren: number; childCopyFailed: boolean }>(
      `/fanza/products/${randomboxId}/copy`,
      body,
    ),

  prizes: (randomboxId: number) =>
    api.get<{
      randomboxId: number;
      items: FzPrize[];
      totalQuantity: number;
      totalDraw: number;
      soldoutCount: number;
    }>(`/fanza/products/${randomboxId}/prizes`),

  updatePrizeQuantity: (
    randomboxId: number,
    prizeId: number,
    quantity: number,
    reason?: string,
  ) =>
    api.patch<{ quantity: number; previousQuantity?: number; changed: boolean }>(
      `/fanza/products/${randomboxId}/prizes/${prizeId}/quantity`,
      reason ? { quantity, reason } : { quantity },
    ),

  prizeHistory: (randomboxId: number, prizeId: number, page = 1) =>
    api.get<Paginated<FzPrizeHistoryEntry>>(
      `/fanza/products/${randomboxId}/prizes/${prizeId}/history${qs({ page, perPage: 20 })}`,
    ),

  /** 원본 prize_modify.php 의 modifyexe. */
  updatePrize: (randomboxId: number, prizeId: number, body: FzPrizeInput) =>
    api.patch<{ prizeId: number }>(`/fanza/products/${randomboxId}/prizes/${prizeId}`, body),

  /** 원본 prize_copy.php: 기존 경품 값을 미리 채운 폼으로 새 경품을 등록한다 — 등록(prize_add.php)과 같은 엔드포인트. */
  createPrize: (randomboxId: number, body: FzPrizeInput) =>
    api.post<{ prizeId: number }>(`/fanza/products/${randomboxId}/prizes`, body),

  deletePrize: (randomboxId: number, prizeId: number) =>
    api.del<{ prizeId: number; deleted: boolean }>(`/fanza/products/${randomboxId}/prizes/${prizeId}`),
};
